/**
 * @generated SignedSource<<5f03a4edf4c4c78198c675271a1f92f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoteCardGenerateAgendaHeadersMutation$variables = {
  noteId: string;
};
export type NoteCardGenerateAgendaHeadersMutation$data = {
  readonly generateAgendaHeaders: {
    readonly headers: ReadonlyArray<{
      readonly content: string;
      readonly id: string;
      readonly subheader: string;
      readonly talkingPoint: string;
    }>;
  } | null;
};
export type NoteCardGenerateAgendaHeadersMutation = {
  response: NoteCardGenerateAgendaHeadersMutation$data;
  variables: NoteCardGenerateAgendaHeadersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "GenerateAgendaHeaders",
    "kind": "LinkedField",
    "name": "generateAgendaHeaders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgendaHeader",
        "kind": "LinkedField",
        "name": "headers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subheader",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "talkingPoint",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteCardGenerateAgendaHeadersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteCardGenerateAgendaHeadersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5e24862102a939efdad35cd595f394cb",
    "id": null,
    "metadata": {},
    "name": "NoteCardGenerateAgendaHeadersMutation",
    "operationKind": "mutation",
    "text": "mutation NoteCardGenerateAgendaHeadersMutation(\n  $noteId: ID!\n) {\n  generateAgendaHeaders(noteId: $noteId) {\n    headers {\n      id\n      content\n      subheader\n      talkingPoint\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b37a24650c76af0c15772c4677ad460";

export default node;
